
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { QuarterlyReportsContent } from '@/components/admin/certificates/QuarterlyReportsContent';

export default function CertificatesReports() {
  return (
    <AdminLayout>
      <QuarterlyReportsContent />
    </AdminLayout>
  );
}
